import React, { useEffect } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { useUserAuth } from '../../providers/auth';
import useCannyClient from '../../hooks/useCannyClient';

export default () => {
  const navigate = useNavigate();
  const { user } = useUserAuth();
  // Send only the path so the API's return_to check (a same-origin path or a
  // URL on the app host) accepts it and rebuilds the absolute URL itself.
  const { pathname, search, hash } = window.location;
  const returnTo = encodeURIComponent(`${pathname}${search}${hash}`);

  useCannyClient(window.Canny);

  useEffect(() => {
    if (!user) {
      navigate(`/users/sign_in?return_to=${returnTo}`);
    }
  }, [user]);

  if (!user) {
    return null;
  }

  return <Outlet />;
};
